import { render, staticRenderFns } from "./DialogNovoModelo.vue?vue&type=template&id=543acbba&scoped=true"
import script from "./DialogNovoModelo.vue?vue&type=script&lang=js"
export * from "./DialogNovoModelo.vue?vue&type=script&lang=js"
import style0 from "./DialogNovoModelo.vue?vue&type=style&index=0&id=543acbba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543acbba",
  null
  
)

export default component.exports